import { createContext } from 'react';
import {
  OpenTaskExecutionDrawerData,
  DrawerContent,
  DrawerTab,
} from 'context/accountDrawer/types';

// Context object lives in its own non-component module so its identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// a new context instance the already-mounted provider doesn't know about.

export interface AccountDrawerControllerContextType {
  drawerContent: DrawerContent | null;
  setDrawerContent: (content: DrawerContent | undefined) => void;
  openTaskExecutionDrawer: (data: OpenTaskExecutionDrawerData) => void;
  /** Raw close — no confirm dialog. Use useAccountDrawer().closeDrawer for the guarded version. */
  closeDrawer: () => void;
  /** Clears modalVisible and optionally switches the active tab, keeping the side tab open. */
  removeModal: (returnTab?: DrawerTab) => void;
}

export const AccountDrawerControllerContext = createContext<
  AccountDrawerControllerContextType | undefined
>(undefined);

AccountDrawerControllerContext.displayName = 'AccountDrawerControllerContext';
